import React from 'react';
import banner from "../Images/about.jpg";
import ScrollReveal from "../Components/ScrollReveal/ScrollReveal";
import KineticText from "../Components/KineticText";

const AboutUs = () => {
    return (
        <div className="overflow-x-hidden">
        <ScrollReveal variant="clip" distance={0}>
          <div className="banner">
            <img alt="" src={banner}/>
            {/* Optional overlay */}
            <div className="overlay"></div>
          </div>
        </ScrollReveal>
        <div className='bg-accent text-primary p-10'>
        <ScrollReveal stagger={0.1}>
          <KineticText as="p" splitBy="char" className="text-center text-5xl pb-10 md:p-10 font-bold heading-font">WHO WE ARE</KineticText>
          <p className="text-center text-3xl pb-10 md:p-10 md:w-[50vw] mx-auto">We are an example of growth and innovation. The 3 pillars that underpin our cosmetic development policy are: innovation, sustainability, and quality.</p>
          <p className="text-center text-3xl pb-10 p-6 md:w-[30vw] mx-auto">We create Perfumery collections for retail chains and leading brands</p>
        </ScrollReveal>
        </div>
      </div>
    );
};

export default AboutUs;